import { TabsContent, TabsList, Tabs as TabsPrimitive, TabsTrigger, cn } from '@consigli/shadcn';

interface TabsProps {
  tabs: Tab[];
  defaultValue?: string;
  value?: string;
  onValueChange?: (value: string) => void;
  className?: string;
  tabListClassName?: string;
  triggerClassName?: string;
}

type Tab = {
  content: React.ReactNode;
  value: string;
  label: string;
};

export const Tabs = ({
  tabs,
  defaultValue,
  value,
  onValueChange,
  className,
  tabListClassName,
  triggerClassName,
}: TabsProps) => {
  return (
    <TabsPrimitive
      defaultValue={defaultValue}
      value={value}
      onValueChange={onValueChange}
      className={cn('w-full', className)}
    >
      <div className="flex justify-center w-full mb-8">
        <TabsList className={cn('bg-gray-200', tabListClassName)}>
          {tabs.map((tab) => (
            <TabsTrigger key={tab.value} value={tab.value} className={cn('px-6', triggerClassName)}>
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </div>
      {tabs.map((tab) => (
        <TabsContent key={tab.value} value={tab.value} className="w-full">
          {tab.content}
        </TabsContent>
      ))}
    </TabsPrimitive>
  );
};
